import { WP_Filter_Children } from '../../model/tags/tags';
import { SanitizeHTML } from '../globals/SanitizeHTML';

interface FilterSubMenuItemProps {
  child?: WP_Filter_Children | null;
  index: number;
  selectedParentTagId: number | null;
  isSubTagSelected: (children, parentId) => boolean;
  selectSubTag: (children, parentId, checked) => void;
}

export const FilterSubMenuItem: React.FC<FilterSubMenuItemProps> = ({
  child,
  index,
  selectedParentTagId,
  isSubTagSelected,
  selectSubTag,
}) => {
  const checked = isSubTagSelected(child?.id, selectedParentTagId);
  return (
    <li key={child?.id} className="w-full py-5 border-b border-gray-200">
      <label
        htmlFor={'' + index + '-' + selectedParentTagId}
        className={`w-full flex items-center justify-between cursor-pointer text-black ${
          checked ? 'font-bold' : 'font-medium'
        }`}
      >
        <SanitizeHTML html={child?.name} />
        <input
          id={'' + index + '-' + selectedParentTagId}
          name={'' + index + '-' + selectedParentTagId}
          className="w-6 h-6 text-primary border-lightGrey focus:ring-transparent rounded-full cursor-pointer"
          type="checkbox"
          onChange={(e) => {
            selectSubTag(child, selectedParentTagId, e.target.checked);
          }}
          checked={checked}
        />
      </label>
    </li>
  );
};
